import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { ToastService } from 'shared';
import { ApiInvestigadorService } from 'src/app/core/services/api-investigador.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-gestiona-api',
  templateUrl: './modal-gestiona-api.component.html',
  styleUrls: ['./modal-gestiona-api.component.scss']
})
export class ModalGestionaApiComponent implements OnInit {

  form: FormGroup;
  environment = environment;
  siteKey = environment.keys.GOOGLE_RECAPTCHA;
  tokenSended = false;
  showError = null;
  loading = false;

  checkSinLimite = false;
  dataValue: any = null;
  constructor(
    private toast: ToastService,
    private store: Store,
    public dialogRef: MatDialogRef<ModalGestionaApiComponent>,
    private formBuilder: FormBuilder,
    private apiInvestigadorService: ApiInvestigadorService,
    @Inject(MAT_DIALOG_DATA) public data: {}
  ) {
    this.dataValue = { ...data };
    this.dataValue.consultasRealizadas = this.dataValue.consultasRealizadas ?? 0;
  }

  ngOnInit(): void {
    this.buildForm();
    this.form.get('cuotaRealizada').disable({ onlySelf: true });
    this.form.get('cuotaRestante').disable({ onlySelf: true })
  }
  buildForm = () => {
    this.form = this.formBuilder.group({
      nombreOrganizacion: [''],
      cuotaAsignada: [this.dataValue.limiteConsultas, [Validators.required]],
      cuotaRealizada: [{ value: this.dataValue.consultasRealizadas, disabled: true }],
      cuotaRestante: [{ value: this.dataValue.limiteConsultas - this.dataValue.consultasRealizadas, disabled: true }],
    });
    this.checkSinLimite = this.dataValue.sinLimite;
  }

  handleClose = () => {
    this.dialogRef.close();
  }

  handleAceptar = () => {
    this.dialogRef.close();
  }

  handleClickSinLimite = () => {
    this.checkSinLimite = !this.checkSinLimite;
  }

  handleEnviar() {
    if (this.loading)
      return false;

    if (this.form.valid) {
      this.loading = true;
      this.apiInvestigadorService.postActualizarCuota({
        tipoInvestigador: this.dataValue.tipoInvestigador,
        tipoDocumento: this.dataValue.tipoDocumento,
        numeroDocumento: this.dataValue.numeroDocumento,
        correo: this.dataValue.correo,
        nuevaCuota: this.form.value.cuotaAsignada,
        month: this.dataValue.mes,
        year: this.dataValue.anio,
        sinLimite: this.checkSinLimite
      }).subscribe((value: any) => {
        this.loading = false;
        if (value.success) {
          this.tokenSended = true
          this.dialogRef.close({ limiteConsultas: this.form.value.cuotaAsignada });
        }
        else
          this.showError = true
      });
    } else {
      this.toast.error('Se actualizó la cuota asignada.');
      this.form.markAllAsTouched();
    }
  }
}
